import dayjs, { Dayjs } from "dayjs";

// Helper function to get the start of a month
function getStartOfMonth(date: dayjs.Dayjs): dayjs.Dayjs {
  return date.startOf("month");
}

// Main function to generate the date list
export function generateDateList(
  startDateStr: number,
  endDateStr: number
): number[] {
  const startDate = dayjs(startDateStr);
  const endDate = dayjs(endDateStr);

  if (startDate.isSame(endDate, "day")) {
    return [startDate.valueOf()];
  }

  const dateList: number[] = [startDate.valueOf()];
  let current = startDate.startOf("month").add(1, "month");

  while (current.isBefore(endDate, "month")) {
    dateList.push(getStartOfMonth(current).valueOf());
    current = current.add(1, "month");
  }

  dateList.push(endDate.valueOf());
  return dateList;
}

// the stored UTC day; dayjs would move a month-end row into the next month east of UTC
export const storedDay = (date: string | Dayjs) =>
  typeof date === "string" ? date.substring(0, 10) : date.format("YYYY-MM-DD");

export const getDominantYearInRange = (
  startDate: Dayjs,
  endDate: Dayjs
): number => {
  const start = startDate.clone().startOf("month");

  const end = endDate.clone().startOf("month");

  const diff = endDate.diff(start, "M");

  let countStartYear = 0;

  let countEndYear = 0;

  let currnt = startDate.clone().startOf("month");

  for (let i = 0; i < diff + 1; i++) {
    const year = currnt.year();

    if (year === start.year()) {
      countStartYear++;
    } else if (year === end.year()) {
      countEndYear++;
    }
    currnt = currnt.add(1, "month");
  }

  const yearToSet = countStartYear >= countEndYear ? start.year() : end.year();

  return yearToSet;
};
